import { c } from 'react-compiler-runtime';
import { useState, useEffect } from 'react';
import classes from './Spinner.module.css.js';
import { clsx } from 'clsx';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useId } from '../hooks/useId.js';
import { VisuallyHidden } from '../VisuallyHidden/VisuallyHidden.js';

const sizeMap = {
  small: '16px',
  medium: '32px',
  large: '64px'
};
function Spinner(t0) {
  var _ariaLabel;
  const $ = c(29);
  let ariaLabel;
  let className;
  let props;
  let style;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      size: t1,
      srText: t2,
      "aria-label": ariaLabel,
      className,
      style,
      delay: t3,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = ariaLabel;
    $[2] = className;
    $[3] = props;
    $[4] = style;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    ariaLabel = $[1];
    className = $[2];
    props = $[3];
    style = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
  }
  const sizeKey = t1 === undefined ? "medium" : t1;
  const srText = t2 === undefined ? "Loading" : t2;
  const delay = t3 === undefined ? false : t3;
  const size = sizeMap[sizeKey];
  const hasHiddenLabel = srText !== null && ariaLabel === undefined;
  const labelId = useId();
  const [isVisible, setIsVisible] = useState(!delay);
  let t4;
  let t5;
  if ($[8] !== delay) {
    t4 = () => {
      if (delay) {
        const timeoutId = setTimeout(() => {
          setIsVisible(true);
        }, 1000);
        return () => clearTimeout(timeoutId);
      }
    };
    t5 = [delay];
    $[8] = delay;
    $[9] = t4;
    $[10] = t5;
  } else {
    t4 = $[9];
    t5 = $[10];
  }
  useEffect(t4, t5);
  if (!isVisible) {
    return null;
  }
  const t6 = (_ariaLabel = ariaLabel) !== null && _ariaLabel !== void 0 ? _ariaLabel : undefined;
  const t7 = hasHiddenLabel ? labelId : undefined;
  let t8;
  if ($[11] !== className) {
    t8 = clsx(className, classes.SpinnerAnimation);
    $[11] = className;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t10;
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = /*#__PURE__*/jsx("circle", {
      cx: "8",
      cy: "8",
      r: "7",
      stroke: "currentColor",
      strokeOpacity: "0.25",
      strokeWidth: "2",
      vectorEffect: "non-scaling-stroke"
    });
    t10 = /*#__PURE__*/jsx("path", {
      d: "M15 8a7.002 7.002 0 00-7-7",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      vectorEffect: "non-scaling-stroke"
    });
    $[13] = t10;
    $[14] = t9;
  } else {
    t10 = $[13];
    t9 = $[14];
  }
  let t11;
  if ($[15] !== props || $[16] !== size || $[17] !== style || $[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
    t11 = /*#__PURE__*/jsxs("svg", {
      height: size,
      width: size,
      viewBox: "0 0 16 16",
      fill: "none",
      "aria-hidden": true,
      "aria-label": t6,
      "aria-labelledby": t7,
      className: t8,
      style: style,
      ...props,
      children: [t9, t10]
    });
    $[15] = props;
    $[16] = size;
    $[17] = style;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== hasHiddenLabel || $[23] !== labelId || $[24] !== srText) {
    t12 = hasHiddenLabel ? /*#__PURE__*/jsx(VisuallyHidden, {
      id: labelId,
      children: srText
    }) : null;
    $[22] = hasHiddenLabel;
    $[23] = labelId;
    $[24] = srText;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t11 || $[27] !== t12) {
    t13 = /*#__PURE__*/jsxs("span", {
      className: classes.Box,
      children: [t11, t12]
    });
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  return t13;
}
Spinner.displayName = 'Spinner';

export { Spinner as default };
